module.exports = __webpack_public_path__ + "img/sw.c0c440bc.png";